import BoostCommerceApi from '../api';
import {
  IActiveCollection,
  IGetFiltersResult,
  ISearchProviderConfig,
} from '../../../types';
import mapFilters from '../helpers/mapFilters';

const GetFilters = (config: ISearchProviderConfig, activeCollection: IActiveCollection, searchTerm: string|null): Promise<IGetFiltersResult> => (new Promise<IGetFiltersResult>((resolve) => {

  const response: IGetFiltersResult = {
    raw: null,
    filters: []
  }

  try {

    BoostCommerceApi(config.apiKey, config.apiEndpoint).request('filter', {
      q: searchTerm ?? '',
      // eslint-disable-next-line camelcase
      build_filter_tree: true,
      // eslint-disable-next-line camelcase
      pf_r_review_ratings_show_exact_rating: true,
      // eslint-disable-next-line camelcase
      collection_scope: activeCollection.id ?? 0
    }).then((res) => {
      // Early resolve if we have no results
      if (typeof res.data === 'undefined' || res.data.filter.options.length === 0) {
        resolve(response)
      }
      // console.log({ response })

      response.filters = mapFilters(res)

      resolve(response)
    })
  } catch (e) {
    console.error(e)
    resolve(response)
  }
}))

export default GetFilters